// extracted by mini-css-extract-plugin
module.exports = {"label-confirm-status":"style_label-confirm-status__WLVwo","label-muted-description":"style_label-muted-description__1eEw7"};